module.exports = __webpack_public_path__ + "static/media/ar-condicionado.ce285bc2.svg";